//main
import ContentFormatXC from "../content/webc/content-format-xc";

import WebbDividerSmall from "../content/webb/webb-divider-sm";
import HeaderSectionDark from "../content/webb/head-section-dark";

import PoapListModule from "../content/transfers/poap-list";
import { UserForm } from "../services/srvc-utilities";

export default function Poaps() {

  return (
  <>
    <ContentFormatXC 
      head='POAPs'
      link={`/${UserForm()}/home`}
      form= 'small'
      data= {
        <>
          <WebbDividerSmall />
          <PoapListModule />

        </>
      } 
    />
  </>
  )
}